import React from 'react';
import { createPortal } from 'react-dom';
import PillsTooltip, { PillsTooltipProps } from './pills-tooltip';

interface Props extends PillsTooltipProps {
  show: boolean;
}

interface State {
  coords: number[];
}

class TooltipPortal extends React.Component<Props, State> {
  el: HTMLElement = document.createElement('div');

  state = {
    coords: [0, 0],
  };

  componentDidMount() {
    document.body.appendChild(this.el);
    window.addEventListener('click', this.handleClick);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
    window.removeEventListener('click', this.handleClick);
  }

  handleClick = e => this.setState({ coords: [e.pageX, e.pageY] });

  render() {
    const { show, ...other } = this.props;
    const { coords } = this.state;

    return (
      show &&
      createPortal(
        <PillsTooltip left={coords[0]} top={coords[1]} {...other} />,
        this.el,
      )
    );
  }
}

export default TooltipPortal;
